// extracted by mini-css-extract-plugin
export default {"workspaceButton":"workspaceButton---eLJZk","workspaceButtonContent":"workspaceButtonContent---kwG6X","workspaceCount":"workspaceCount---ZAUxX"};